import React from 'react';
import { Text, RTNLink, RtnIcon } from '@rtn-web/evergreen';

export default function PartnerSignIn({
  email, partnerRedirect, partnerImage, urlParams,
}) {
  return (
    <div className="grid-x partner-login-container">
      <div className="small-12 text-center">
        {partnerImage
          ? <img src={partnerImage.image} alt={partnerImage.altText || 'partner'} />
          : <RtnIcon name="HandShake" />}
      </div>
      <div
        className="small-12 text-center pt-16"
      >
        <Text tag="h3" variant="para-bold-large-center" text={email} />
        <Text tag="p" variant="para-semibold-medium-center" text="It looks like you usually sign into your Roadtrip Nation account through another site! Click the button below to continue signing in." />
      </div>
      <div className="text-center small-12">
        <div style={{ width: '291px', margin: '32px auto' }}>
          <RTNLink SecondaryBtn arrow sameWindow link={partnerRedirect} text="Continue to partner site" />
        </div>
      </div>
      <div className="small-12 text-center">
        <RTNLink sameWindow link={`/user/login?${urlParams}`} text="I want to sign in with a different username or email" />
      </div>
    </div>
  );
}
